import {AxiosServer, AxiosEsb,ArrRemoveSubItem} from '../../utils';
import {message} from 'antd';
import {server} from "../../config";

let namespace = 'purorder_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const purorderAc = {
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},		

	GET:(value)=>(dispatch,getState)=>{
		let store =getState().purOrderRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}		
		let Axios = AxiosServer();		

		return Axios.post('/purOrder/findAll',dataFetchProps).then((res)=>{	
							
			if (res.data.status == true){				
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}}); // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('orderList ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})
	},		
	
	
	// 将上传的文件保存到purOrderFile表。
	TOFILE:(value)=>(dispatch,getState)=>{			
		let Axios = AxiosServer();
		return  Axios.post('/purOrderFile/create',value).then((res)=>{		
		   
			//更新成功，重新获取数据			
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}}); 		   
			return '上传成功';
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},	
	
	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错
		let id = parseInt(value.id);			
		
		let Axios = AxiosServer();
		return  Axios.post('/purOrder/update',value).then((res)=>{	
		
			if (res.data.status){
				//更新成功，重新获取数据			
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}}); 
				return '更新成功'
			}
			return '更新失败'
			
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},

	// 将上传的文件更新到purOrderFile表。
	UPDATEFILE:(value)=>(dispatch,getState)=>{
		let Axios = AxiosServer();
		return  Axios.post('/purOrderFile/update',value).then((res)=>{

			//更新成功，重新获取数据
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
			return '上传成功';
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},

	ESBTOSFTP:(id)=> (dispatch,getState)=>{

		let Axios = AxiosEsb();

		return  Axios.post('/api/towxsbank/pur/sendToSftp',{id:id}).then((res)=>{

			//更新成功，重新获取数据
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
			return '更新成功'
		}).catch((err)=>{
			console.log('err:',err);
			return 'error'
		})

	},
	ESBTOSUPPLY:(value)=> (dispatch,getState)=>{

		let Axios = AxiosEsb();

		return  Axios.post('/api/towxsbank/supplyMaterailOtcg',{id:value.id}).then((res)=>{

			//提交成功，更新数据

			if (res.data.status){

				//更新后台为同意

				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return res.data.msg
			}

			return res.data.msg;


		}).catch((err)=>{
			console.log('err:',err);
			return 'error'
		})

	},
	//复制合同功能
	COPYPURORDER:(value)=> (dispatch,getState)=>{
		let Axios =AxiosServer();

		return  Axios.post('/purOrder/copy',{id:value}).then((res)=>{

			//提交成功，更新数据

			if (res.data.status){

				//更新后台为同意

				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return res.data.msg
			}

			return res.data.msg;


		}).catch((err)=>{
			console.log('err:',err);
			return '复制失败'
		})

	},
	//导出excel文件
	GETXLS:()=>(dispatch,getState)=>{
		let store =getState().purOrderRd;
		let {dataFetchProps,searchProps} =store;
		let props ={...dataFetchProps,...searchProps,pageSize: 5000};
		let Axios = AxiosServer();
		return Axios.post('/api/excel/export/purOrder',props).then((res)=>{
			if (res.data.filename){
				return (server.path+ res.data.filename);
			}else{
				return '下载失败';
			}

		}).catch((err)=>{
			message.error('错误:' + err.message,10);
			return '错误'
		})
	},
}


export {purorderAc};